import { createFileRoute } from '@tanstack/react-router';
import { AdminOverviewScreen } from '@/features/admin/AdminOverviewScreen';

export const Route = createFileRoute('/_app/admin/')({
  component: AdminOverviewScreen,
});
